module.exports = "/img/_/_/_/assets/images/creeper/book/common//36.jpg?253d511405a175ea48c73d465a2418bf";